type FeatureKey = keyof typeof CONFIG;

const CONFIG = {
  categoricalBarToXY: 'atlas-01',
};

export function isFeatureEnabled(key: FeatureKey): boolean {
  const urlParam = new URLSearchParams(window.location.search);
  return urlParam.get(key) === CONFIG[key];
}
